import { ApiError, meSchema, queryKeys, type Me } from '@fidalia/api';
import { Spinner } from '@fidalia/ui';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { AppLayout } from '@/features/app/app-layout';

/**
 * Layout des écrans connectés. Le garde vérifie la session auprès du backend
 * plutôt que la simple présence d'un jeton : un jeton expiré ou révoqué ne
 * doit pas laisser entrevoir l'application. Le contrôle réel reste serveur.
 */
export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context }) => {
    if (context.tokens.get() === null) throw redirect({ to: '/login' });

    try {
      // Mise en cache partagée avec `useMe()` : aucun appel en double.
      const me = await context.queryClient.ensureQueryData({
        queryKey: queryKeys.auth.me(),
        queryFn: () => context.api.get<Me>('/auth/me', { schema: meSchema }),
        staleTime: 5 * 60_000,
      });

      return { me };
    } catch (error) {
      if (error instanceof ApiError && error.status === 401) {
        // `raison` porte le code du backend quand il en donne un : l'écran de
        // connexion affiche « accès désactivé » plutôt que « session expirée ».
        throw redirect({ to: '/login', search: error.code ? { raison: error.code } : {} });
      }
      throw error;
    }
  },
  pendingComponent: () => (
    <div className="fixed inset-0 grid place-items-center bg-surface">
      <Spinner />
    </div>
  ),
  component: () => (
    <AppLayout>
      <Outlet />
    </AppLayout>
  ),
});
